/* Shin Oak in-page link glide. 24 Sept 2026.
   A link to #so-... on the same page scrolls smoothly, stops just below the
   pinned header, moves keyboard and screen-reader focus to the target, then
   gives the target a brief glow so the customer sees where they landed.
   Arriving from another page with a #so-... address gets the same landing,
   but only on a fresh visit: a reload or Back/Forward keeps the browser's own
   restored position. The moment the customer scrolls, taps or presses a key
   during a glide, the script lets go. Reduced-motion visitors get a plain
   jump and no glow. */
(function () {
  if (window.__soGlide) return;
  window.__soGlide = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var activeWatch = null;
  var userTookOver = false;

  function stopWatch() {
    if (activeWatch) {
      window.clearInterval(activeWatch);
      activeWatch = null;
    }
  }

  function customerMoved() {
    userTookOver = true;
    stopWatch();
  }
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
    window.addEventListener(type, customerMoved, { passive: true });
  });

  function headerOffset() {
    var header = document.querySelector('.section-header');
    if (!header) return 12;
    var pos = window.getComputedStyle(header).position;
    if (pos === 'sticky' || pos === 'fixed') {
      /* The ticker can be pinned above the header (17 Oct 2026): count it too, so a
         link never lands under the pinned bars. 0 when the ticker is not pinned. */
      var tick = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--so-ticker-h')) || 0;
      return Math.round(header.getBoundingClientRect().height + tick) + 12;
    }
    return 12;
  }

  function glow(el) {
    if (reduceMotion) return;
    if (el.__soGlowTimer) window.clearTimeout(el.__soGlowTimer);
    el.classList.remove('so-arrive');
    void el.offsetWidth;
    el.style.setProperty('--so-arrive-base', window.getComputedStyle(el).backgroundColor);
    el.classList.add('so-arrive');
    el.__soGlowTimer = window.setTimeout(function () {
      el.classList.remove('so-arrive');
      el.__soGlowTimer = null;
    }, 1800);
  }

  function arrive(el) {
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      /* focus is a courtesy for keyboard and screen-reader users; never block the landing */
    }
    glow(el);
  }

  function whenScrollSettles(done) {
    var lastY = -1, stillTicks = 0, waited = 0;
    var timer = window.setInterval(function () {
      var y = window.pageYOffset;
      stillTicks = (y === lastY) ? stillTicks + 1 : 0;
      lastY = y;
      waited += 60;
      if (stillTicks >= 3 || waited >= 2000) {
        window.clearInterval(timer);
        done();
      }
    }, 60);
  }

  /* Arrive only once the page has actually reached the target. If a browser
     never starts the smooth scroll (throttled or unsupported), jump there
     after 0.7s so the customer always reaches the section. If the customer
     takes over the scroll, stop without any forced jump or glow. */
  function glideTo(el) {
    stopWatch();
    userTookOver = false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var goal = Math.min(Math.max(0, Math.round(top)), maxY);
    var startY = window.pageYOffset;
    try {
      window.scrollTo({ top: goal, behavior: reduceMotion ? 'auto' : 'smooth' });
    } catch (err) {
      window.scrollTo(0, goal);
    }
    var elapsed = 0;
    activeWatch = window.setInterval(function () {
      if (userTookOver) {
        stopWatch();
        return;
      }
      elapsed += 60;
      var y = window.pageYOffset;
      if (Math.abs(y - goal) <= 2) {
        stopWatch();
        arrive(el);
        return;
      }
      if (elapsed >= 700 && Math.abs(y - startY) <= 2) window.scrollTo(0, goal);
      if (elapsed >= 2400) {
        stopWatch();
        window.scrollTo(0, goal);
        arrive(el);
      }
    }, 60);
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target && e.target.closest ? e.target.closest('a[href*="#so-"]') : null;
    if (!link) return;
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    if (window.history) {
      if (url.hash === window.location.hash) {
        if (window.history.replaceState) window.history.replaceState(null, '', url.hash);
      } else if (window.history.pushState) {
        window.history.pushState(null, '', url.hash);
      }
    }
    glideTo(target);
  });

  /* Tell the browser where to stop for #so- targets, so its own jump (when a
     customer arrives from another page) also lands below the pinned header. */
  function publishOffset() {
    document.documentElement.style.setProperty('--so-header-offset', headerOffset() + 'px');
  }
  publishOffset();
  window.addEventListener('resize', publishOffset);
  window.addEventListener('load', publishOffset);

  var navEntry = (window.performance && window.performance.getEntriesByType) ? window.performance.getEntriesByType('navigation')[0] : null;
  var freshVisit = !navEntry || navEntry.type === 'navigate';
  if (freshVisit && window.location.hash.indexOf('#so-') === 0) {
    var landing = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (landing) {
      var settle = function () {
        window.setTimeout(function () {
          if (userTookOver) return;
          whenScrollSettles(function () {
            if (userTookOver) return;
            publishOffset();
            var miss = Math.abs(landing.getBoundingClientRect().top - headerOffset());
            if (miss > 24) glideTo(landing); else arrive(landing);
          });
        }, 150);
      };
      if (document.readyState === 'complete') settle(); else window.addEventListener('load', settle);
    }
  }
})();
